// Angular modules.
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
// Third-party modules.
import { TranslateService } from '@ngx-translate/core';
// Zenklub interfaces.
import {
	IAvailability,
	IAvailabilityApi,
} from 'app/interfaces/availability.interface';
// Zenklub services.
import { AvailabilitiesService } from 'app/services/availabilities.service';
import { DateTimeService } from 'app/services/datetime.service';
import { UserService } from 'app/services/user.service';

@Component({
	selector: 'app-mobavailabilities-list',
	templateUrl: './mobavailabilities-list.component.html',
	styleUrls: ['./mobavailabilities-list.component.scss'],
})
export class MobAvailabilitiesListComponent implements OnInit {
	// Outputs.
	@Output() addAvailability: EventEmitter<any> = new EventEmitter<any>();
	@Output() editAvailability: EventEmitter<IAvailability> =
		new EventEmitter<IAvailability>();
	// Availabilities.
	avList: IAvailabilityApi[] = [];
	daysOfWeek: string[] = [];
	// User's data.
	userCountry = 'br';
	// Status
	isLoading = false;
	// Constructor method.
	constructor(
		protected availabilities: AvailabilitiesService,
		protected dateTime: DateTimeService,
		protected user: UserService,
		protected translate: TranslateService
	) {}

	// On init.
	public ngOnInit(): void {
		// Loader.
		this.isLoading = true;
		// Get user's country.
		this.userCountry = this.user.getUserCountry();
		// Get current availabilities.
		this.availabilities.getAll().subscribe((res) => {
			this.avList = res;
			// Get the names of days of week.
			this.daysOfWeek = [];
			for (let i = 0; i <= 6; i++) {
				const r = this.dateTime.getWeekdayName(i);
				this.daysOfWeek.push(r.ABB);
			}
			// Loader.
			this.isLoading = false;
		});
	}

	// Add new availability.
	public add(): void {
		this.addAvailability.emit();
	}

	// Edit an availability.
	public edit(availability: IAvailability): void {
		this.editAvailability.emit(availability);
	}

	// Remove an availability.
	public remove(id: IAvailabilityApi['id']): void {
		if (confirm(this.translate.instant('MESSAGES.CONFIRMREMOVEITEM'))) {
			this.availabilities.remove(id).subscribe(() => {
				this.avList.forEach((item, index) => {
					if (item.id === id) {
						this.avList.splice(index, 1);
						return false;
					}
				});
			});
		}
	}
}
